import { HOST, ENDPOINTS } from '../constants/api';

export function updateSelectedShoppingList(data) {
    data = {
        shopping_lists_id: data
    }
    return window.axios.post(ENDPOINTS.updateSelectedShoppingList, data);
}

export function updateSelectedVault(data) {
    data = {
        selected_vault_id: data
    }
    return window.axios.post(ENDPOINTS.updateSelectedVault, data);
}

export function updateSelectedRecipeBook(data) {
    data = {
        selected_recipe_book_id: data
    }
    return window.axios.post(ENDPOINTS.updateSelectedRecipeBook, data);
}

export function getShoppingLists() {
    return window.axios.get(ENDPOINTS.getShoppingLists);
}

export function createShoppingList(data) {
    return window.axios.post(ENDPOINTS.createShoppingList, data);
}

export function deleteShoppingList(id) {
    return window.axios.post(ENDPOINTS.deleteShoppingList, { id });
}

export function getShoppingListItems(id) {
    return window.axios.get(ENDPOINTS.getShoppingListItems, { params: { shopping_lists_id: id } });
}

export function createShoppingListItem(data) {
    return window.axios.post(ENDPOINTS.createShoppingListItem, data);
}

export function updateShoppingListItem(request) {
    return window.axios.post(ENDPOINTS.updateShoppingListItem, request);
}

export function deleteShoppingListItem(id) {
    return window.axios.post(ENDPOINTS.deleteShoppingListItem, { id });
}

export function getVaultItems() {
    return window.axios.get(ENDPOINTS.getVaultItems);
}

export function getVaults() {
    return window.axios.get(ENDPOINTS.getVaults);
}

export function createVaultItem(data) {
    return window.axios.post(ENDPOINTS.createVaultItem, data);
}

export function revealVaultItem(id) {
    return window.axios.post(ENDPOINTS.revealVaultItem, { id });
}

export function enableVaultItemTotp(id, secret) {
    return window.axios.post(ENDPOINTS.enableVaultItemTotp, { id, secret });
}

export function getVaultItemTotpCode(id) {
    return window.axios.post(ENDPOINTS.getVaultItemTotpCode, { id });
}

export function disableVaultItemTotp(id) {
    return window.axios.post(ENDPOINTS.disableVaultItemTotp, { id });
}

export function getVaultItemHistory(id) {
    return window.axios.post(ENDPOINTS.getVaultItemHistory, { id });
}

export function restoreVaultItemVersion(id, versionId) {
    return window.axios.post(ENDPOINTS.restoreVaultItemVersion, { id, version_id: versionId });
}

export function updateVaultItem(data) {
    return window.axios.post(ENDPOINTS.updateVaultItem, data);
}

export function deleteVaultItem(id) {
    return window.axios.post(ENDPOINTS.deleteVaultItem, { id });
}

export function createVault(data) {
    return window.axios.post(ENDPOINTS.createVault, data);
}

export function updateVault(data) {
    return window.axios.post(ENDPOINTS.updateVault, data);
}

export function deleteVault(id) {
    return window.axios.post(ENDPOINTS.deleteVault, { id });
}

export function shareVault(data) {
    return window.axios.post(ENDPOINTS.shareVault, data);
}

export function unshareVault(data) {
    return window.axios.post(ENDPOINTS.unshareVault, data);
}

export function getVaultShareUsers() {
    return window.axios.get(ENDPOINTS.getVaultShareUsers);
}

export function getMe() {
    return window.axios.get(ENDPOINTS.getMe);
}

export function getUsers() {
    return window.axios.get(ENDPOINTS.getUsers);
}

export function createUser(data) {
    return window.axios.post(ENDPOINTS.createUser, data);
}

export function updateUser(data) {
    return window.axios.post(ENDPOINTS.updateUser, data);
}

export function deleteUser(data) {
    return window.axios.post(ENDPOINTS.deleteUser, data);
}

export function lookupUserByEmail(data) {
    return window.axios.post(ENDPOINTS.lookupUserByEmail, data);
}

export function assignVaultToUser(data) {
    return window.axios.post(ENDPOINTS.assignVaultToUser, data);
}

export function removeVaultFromUser(data) {
    return window.axios.post(ENDPOINTS.removeVaultFromUser, data);
}

// ==================== RECIPE BOOKS ====================

export function createRecipeBook(data) {
    return window.axios.post(ENDPOINTS.createRecipeBook, data);
}

export function getRecipeBooks() {
    return window.axios.get(ENDPOINTS.getRecipeBooks);
}

export function updateRecipeBook(data) {
    return window.axios.post(ENDPOINTS.updateRecipeBook, data);
}

export function deleteRecipeBook(id) {
    return window.axios.post(ENDPOINTS.deleteRecipeBook, { id });
}

export function shareRecipeBook(data) {
    return window.axios.post(ENDPOINTS.shareRecipeBook, data);
}

export function unshareRecipeBook(data) {
    return window.axios.post(ENDPOINTS.unshareRecipeBook, data);
}

export function getRecipeBookShareUsers() {
    return window.axios.get(ENDPOINTS.getRecipeBookShareUsers);
}

// ==================== RECIPES ====================

export function getRecipesByBook(bookId, pageOrParams = 1) {
    if (typeof pageOrParams === 'object') {
        // Accept a params object: { page, per_page, light, ... }
        return window.axios.get(ENDPOINTS.getRecipesByBook, { params: { recipe_book_id: bookId, ...pageOrParams } });
    }
    return window.axios.get(ENDPOINTS.getRecipesByBook, { params: { recipe_book_id: bookId, page: pageOrParams } });
}

export function getRecipesFromAllBooks(page = 1) {
    return window.axios.get(ENDPOINTS.getRecipesFromAllBooks, { params: { page } });
}

export function getRecipesFromAllBooksList(page = 1) {
    return window.axios.get(ENDPOINTS.getRecipesFromAllBooksList, { params: { page } });
}

export function getRecipeDetail(recipeId) {
    return window.axios.get(ENDPOINTS.getRecipeDetail, { params: { recipe_id: recipeId } });
}

export function generateShareToken(recipeId) {
    return window.axios.post(ENDPOINTS.generateShareToken, { recipe_id: recipeId });
}

export function revokeShareToken(recipeId) {
    return window.axios.post(ENDPOINTS.revokeShareToken, { recipe_id: recipeId });
}

export function addRecipe(data) {
    return window.axios.post(ENDPOINTS.addRecipe, data);
}

export function updateRecipe(data) {
    return window.axios.post(ENDPOINTS.updateRecipe, data);
}

export function deleteRecipe(id) {
    return window.axios.post(ENDPOINTS.deleteRecipe, { id });
}

// ==================== INGREDIENTS ====================

export function addIngredient(data) {
    return window.axios.post(ENDPOINTS.addIngredient, data);
}

export function updateIngredient(data) {
    return window.axios.post(ENDPOINTS.updateIngredient, data);
}

export function deleteIngredient(id) {
    return window.axios.post(ENDPOINTS.deleteIngredient, { id });
}

// ==================== IMPORTS ====================

export function importRecipeByUrl(data) {
    return window.axios.post(ENDPOINTS.importRecipeUrl, data);
}

export function importRecipeByText(data) {
    return window.axios.post(ENDPOINTS.importRecipeText, data);
}

export function uploadRecipeImage(formData) {
    return window.axios.post(ENDPOINTS.uploadRecipeImage, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

export function importRecipeHtml(formData) {
    return window.axios.post(ENDPOINTS.importRecipeHtml, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

// ==================== NURA BABY ====================

// The import endpoint joins the session email to the Nura app's Firebase
// account server-side (Admin SDK), so the normal Authentik session token is
// enough — no Firebase sign-in needed.
export function importNuraCsv(formData) {
    return window.axios.post(ENDPOINTS.nuraImport, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

// ==================== CATEGORIES ====================

export function getCategories(params = {}) {
    return window.axios.get(ENDPOINTS.getCategories, params);
}

export function getRecipesByCategory(bookId, categoryId, page = 1) {
    return window.axios.get(ENDPOINTS.getRecipesByCategory, {
        params: { recipe_book_id: bookId, category_id: categoryId, page }
    });
}

export function searchRecipes(bookId, query, categoryId = null) {
    const params = { recipe_book_id: bookId, q: query };
    if (categoryId) params.category_id = categoryId;
    return window.axios.get(ENDPOINTS.searchRecipes, { params });
}

export function assignCategoriesToRecipe(recipeId, categoryIds) {
    return window.axios.post(ENDPOINTS.assignCategoriesToRecipe, {
        recipe_id: recipeId,
        category_ids: categoryIds
    });
}

export function getCategoryStats(bookId) {
    return window.axios.get(ENDPOINTS.getCategoryStats, {
        params: { recipe_book_id: bookId }
    });
}
